import { AbstractListSelectors } from '../abstract/selectors';

export default class Selectors extends AbstractListSelectors {
  constructor({ accessorChain = [] }) {
    super({ accessorChain });
  }
}
